module.exports = __webpack_public_path__ + "img/Number=23.771cb8c8.png";